import {
  useAssetCategoriesSearchListLazyQuery,
  useDepartmentsSearchListLazyQuery,
  useEdmDocumentationCategoriesSearchListLazyQuery,
  useInterventionCategoriesSearchListLazyQuery,
  useUsersSearchListLazyQuery,
} from 'graphql-common';
import { getUsersLoadOptions as getUsersLoadOptionsFn } from 'utils/fetch/searchLists/usersSearchList';
import { getDepartmentsLoadOptions as getDepartmentsLoadOptionsFn } from 'utils/fetch/searchLists/departmentsSearchList';
import { getInterventionCategoriesLoadOptions as getInterventionCategoriesLoadOptionsFn } from 'utils/fetch/searchLists/interventionCategoriesSearchList';
import { getAssetCategoriesLoadOptions as getAssetCategoriesLoadOptionsFn } from 'utils/fetch/searchLists/assetCategoriesSearchList';
import { getDocumentationCategoriesLoadOptions as getDocumentationCategoriesLoadOptionsFn } from 'utils/fetch/searchLists/documentationCategoriesSearchList';

export default function useSearchListQueries() {
  // Users
  const [fetchUsersSearchListLazyQuery] = useUsersSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getUsersLoadOptions = () => {
    return getUsersLoadOptionsFn(fetchUsersSearchListLazyQuery);
  };

  // Intervention categories
  const [fetchInterventionCategoriesLazyQuery] =
    useInterventionCategoriesSearchListLazyQuery({
      fetchPolicy: 'cache-and-network',
    });
  const getInterventionCategoriesLoadOptions = () =>
    getInterventionCategoriesLoadOptionsFn(
      fetchInterventionCategoriesLazyQuery,
    );

  // Asset categories
  const [fetchAssetCategoriesLazyQuery] = useAssetCategoriesSearchListLazyQuery(
    {
      fetchPolicy: 'cache-and-network',
    },
  );
  const getAssetCategoriesLoadOptions = () =>
    getAssetCategoriesLoadOptionsFn(fetchAssetCategoriesLazyQuery);

  // Documentation categories
  const [fetchDocumentationCategoriesLazyQuery] =
    useEdmDocumentationCategoriesSearchListLazyQuery({
      fetchPolicy: 'cache-and-network',
    });
  const getDocumentationCategoriesLoadOptions = () =>
    getDocumentationCategoriesLoadOptionsFn(
      fetchDocumentationCategoriesLazyQuery,
    );

  // Departments
  const [fetchDepartmentsSearchListLazyQuery] =
    useDepartmentsSearchListLazyQuery({
      fetchPolicy: 'cache-and-network',
    });
  const getDepartmentsLoadOptions = () =>
    getDepartmentsLoadOptionsFn(fetchDepartmentsSearchListLazyQuery);

  return {
    getUsersLoadOptions,
    getInterventionCategoriesLoadOptions,
    getAssetCategoriesLoadOptions,
    getDocumentationCategoriesLoadOptions,
    getDepartmentsLoadOptions,
    fetchUsersSearchListLazyQuery,
    fetchInterventionCategoriesLazyQuery,
    fetchAssetCategoriesLazyQuery,
    fetchDocumentationCategoriesLazyQuery,
  };
}
